<template>
  <a-dialog ref="dialog" size="small" name="remove_checks" :loading="loading" @open="opened" @close="$reset">
    <span slot="title">{{ $t('title') }}</span>
    <div slot="content">
      {{ $t('confirmation', {ids: ids.length}) }}

    </div>
    <span slot="actions">
      <v-btn color="error" text @click="submit">
          {{ $t('remove', {ids: ids.length}) }}
      </v-btn>
    </span>
  </a-dialog>
</template>

<script>
export default {
  name: 'RemoveCheckDialog',
  data() {
    return {
      loading: '',
      ids: []
    }
  },
  methods: {
    opened({ids}) {
      if (ids.length === 0) {
        this.$ui.warning(this.$t('ui-warning-empty'))
        if (this.$refs.dialog) this.$refs.dialog.close()
      }

      this.ids = ids
    },
    async submit() {
      this.loading = this.$t('ui-remove-verifications')

      try {
        await this.$api.post('checks/remove', {ids: this.ids})
        this.$ui.success(this.$t('ui-success'))
        this.$bus.emit('datacenter_check/require_refresh')
        if (this.$refs.dialog) this.$refs.dialog.close()
      } finally {
        this.loading = ''
      }
    }
  }
}
</script>

<i18n>
{
	"en": {
		"confirmation": "Are you sure you want to delete {ids} checks? This action is irreversible and the historical data will be deleted.",
		"remove": "Delete {ids.length} verification(s)",
		"title": "Delete Checks",
		"ui-remove-verifications": "Deletion of checks ...",
		"ui-success": "The checks were successfully removed.",
		"ui-warning-empty": "You must select at least one check to delete."
	},
	"es": {
		"confirmation": "¿Está seguro de que desea eliminar {ids} verificacione(s)? Esta acción es irreversible y se eliminarán los datos históricos.",
		"remove": "Eliminar {ids.length} verificacione(s)",
		"title": "Eliminar verificatione(s)",
		"ui-remove-verifications": "Eliminación de las verificaciones ...",
		"ui-success": "Las verificaciones se eliminaron con éxito.",
		"ui-warning-empty": "Debe seleccionar al menos una verificación para eliminar."
	},
	"fr": {
		"confirmation": "Souhaitez-vous réellement supprimer {ids} vérifications ? Cette action est irreversible et les données d'historique seront supprimées.",
		"remove": "Supprimer {ids.length} vérification(s)",
		"title": "Supprimer des vérifications",
		"ui-remove-verifications": "Suppression des vérifications ...",
		"ui-success": "Les vérifications ont été supprimés avec succès.",
		"ui-warning-empty": "Vous devez sélectionner au moins une vérification à supprimer."
	},
	"it": {
		"confirmation": "Sei sicuro di voler eliminare {ids} verifiche? Questa azione è irreversibile e i dati storici verranno eliminati.",
		"remove": "Elimina {ids.length} verifica/e",
		"title": "Elimina verifiche",
		"ui-remove-verifications": "Eliminazione delle verifiche ...",
		"ui-success": "Le verifiche sono state rimosse con successo.",
		"ui-warning-empty": "Devi selezionare almeno una verifica da eliminare."
	},
	"pt": {
		"confirmation": "Tem a certeza de que deseja eliminar {ids} verificações? Esta ação é irreversível e os dados históricos serão eliminados.",
		"remove": "Eliminar {ids.length} verificação(ões)",
		"title": "Eliminar verificações",
		"ui-remove-verifications": "A eliminar verificações ...",
		"ui-success": "As verificações foram removidas com sucesso.",
		"ui-warning-empty": "Deve selecionar pelo menos uma verificação para eliminar."
	},
	"pl": {
		"confirmation": "Czy na pewno chcesz usunąć {ids} sprawdzeń? Ta akcja jest nieodwracalna i dane historyczne zostaną usunięte.",
		"remove": "Usuń {ids.length} weryfikację(e)",
		"title": "Usuń sprawdzenia",
		"ui-remove-verifications": "Usuwanie sprawdzeń ...",
		"ui-success": "Sprawdzenia zostały pomyślnie usunięte.",
		"ui-warning-empty": "Musisz wybrać co najmniej jedno sprawdzenie do usunięcia."
	}
}
</i18n>
